module.exports = __webpack_public_path__ + "static/img/ceres.6a856ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ceres.jpg
// module id = 9wwO
// module chunks = 0